import { render, staticRenderFns } from "./setting-erp.vue?vue&type=template&id=54651ea6"
import script from "./setting-erp.vue?vue&type=script&lang=js"
export * from "./setting-erp.vue?vue&type=script&lang=js"
import style0 from "./setting-erp.vue?vue&type=style&index=0&id=54651ea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports